import CryptoJS from 'crypto-js';

const SECRET_KEY = '12345678901234567890123456789012';

function decryptResponse({ iv, data }) {
  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const ivBytes = CryptoJS.enc.Hex.parse(iv);
  const encryptedData = CryptoJS.enc.Hex.parse(data);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encryptedData },
    key,
    {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export async function fetchData(endPoint) {
  const token = localStorage.getItem("token");
  const response = await fetch(`http://localhost:5000/api/${endPoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Unauthorized');
  }

  const encryptedResponse = await response.json();

  try {
    const decryptedString = decryptResponse(encryptedResponse);
    return JSON.parse(decryptedString);
  } catch (e) {
    throw new Error('Failed to decrypt or parse data.');
  }
}

export async function updateData(endPoint, data) {
  const token = localStorage.getItem("token");
  const response = await fetch(`http://localhost:5000/api/${endPoint}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errText = await response.text();
    throw new Error('Failed to update : ' + errText);
  }

  const encryptedResponse = await response.json();

  try {
    const decryptedString = decryptResponse(encryptedResponse);
    return JSON.parse(decryptedString);
  } catch (e) {
    throw new Error('Failed to decrypt or parse response.');
  }
}

export async function deleteData(endPoint) {
  const token = localStorage.getItem("token");
  const response = await fetch(`http://localhost:5000/api/${endPoint}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errText = await response.text();
    throw new Error('Failed to delete: ' + errText);
  }

  const encryptedResponse = await response.json();

  try {
    const decryptedString = decryptResponse(encryptedResponse);
    return JSON.parse(decryptedString);
  } catch (e) {
    throw new Error('Failed to decrypt or parse delete response.');
  }
}

export async function createData(endpoint, data) {
  const token = localStorage.getItem('token');

  const response = await fetch(`http://localhost:5000/api/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const err = await response.text();
    throw new Error('Failed to create user: ' + err);
  }

  return response.json();
}